import App from './app.svelte';
import page from '../page';
import store from '../store/app';

export default page(App, store);